import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AddOrganizationReqVM } from 'src/app/viewModels/organization/add-organization-req-vm';
import { CommonService } from 'src/app/middleware/common/common.service';
import { OrganizationService } from '../services/organization/organization.service';

@Component({
  selector: 'app-edit-organizations',
  templateUrl: './edit-organizations.component.html',
  styleUrls: ['./edit-organizations.component.scss']
})
export class EditOrganizationsComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private customValidator: CustomvalidationService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private loaderService: LoaderService,
    private toastr: ToastrService, private router: Router,
    private addOrgVm: AddOrganizationReqVM, private organizationService: OrganizationService,
    private commonService: CommonService) {
    this.getCountryListDropdown();

    this.updateOrganizationForm = this.formBuilder.group({
      organizationName: ['', Validators.required],
      address1: ['', Validators.required],
      address2: [''],
      cityId: ['', Validators.required],
      stateId: ['', Validators.required],
      countryId: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      organizationType: ['', Validators.required],
      isActive: [''],
      zipCode: ['', Validators.required]
    });
    let data = [];
    data = this.commonService.getEditData();
    if(data !=undefined){
    
    this.isEdit = data[0];
    this.organization = data[1];
 
    this.updateOrganizationDetail.organizationID = this.organization.organizationID;
    this.updateOrganizationDetail.organizationName = this.organization.organizationName;
    this.updateOrganizationDetail.address1 = this.organization.address1;
    this.updateOrganizationDetail.address2 = this.organization.address2;
   
    this.updateOrganizationDetail.countryID = this.organization.countryID;
    this.getStateDropdownList();
    this.updateOrganizationDetail.organizationType = this.organization.organizationType;
    if (this.organization.organizationType == "Dedicated") {
      this.updateOrganizationDetail.organizationType = 2;
    }
    else {
      this.updateOrganizationDetail.organizationType = 1;
    }
    this.updateOrganizationDetail.phoneNumber = this.organization.phoneNumber;    
    this.updateOrganizationDetail.stateID = this.organization.stateID;
    this.getCityDropdownList();
    this.updateOrganizationDetail.cityID = this.organization.cityID;
    this.updateOrganizationDetail.zipCode = this.organization.zipCode;
    this.updateOrganizationDetail.organizationName = this.organization.organizationName;
    this.updateOrganizationDetail.email = this.organization.email;
    // if(this.organization.isActive=="In-Active"){
    //   var status =false;
    // }else{
    //   status =true;
    // }
    this.updateOrganizationDetail.isActive =this.organization.isActive;
   }
  }


  organizationTypeList: any[] = [];
  updateOrganizationForm: FormGroup;
  updateOrganizationDetail: AddOrganizationReqVM = new AddOrganizationReqVM();
  isEdit: boolean;
  organization: any;
  updatePermissionResponseHolder: any;
  showErrorMessage: boolean = false;
  coutryListResponseHolder: any;
  countryList: any[];
  stateList: any[];
  cityList: any[];
  stateListRResponseHolder: any;
  cityListRResponseHolder: any;
  @Output() closeSidePanel = new EventEmitter();
  

  ngOnInit(): void {
    this.organizationTypeList = [
      { id: 1, name: 'Shared' },
      { id: 2, name: 'Dedicated' }
    ];

  }

  close() {
    //this.dialogRef.close();
    let closePanel = false;
    this.closeSidePanel.emit(closePanel);
  }

  // Get Errors for phoneNumber field
  getPhoneErrorMessage() {
    return this.customValidator.getPhoneErrorMessage(this.updateOrganizationForm);
  }

  updateOrganization(formValues) {
    if (formValues != undefined) {
      //this.addOrgVm.email = formValues.email;
      this.addOrgVm.isActive = formValues.isActive;
      this.addOrgVm.organizationName = formValues.organizationName;
      this.addOrgVm.organizationType = this.updateOrganizationDetail.organizationType;
      //this.addOrgVm.password = formValues.password;
      this.addOrgVm.phoneNumber = formValues.phoneNumber;
      this.addOrgVm.stateID = parseInt(formValues.stateId);
      this.addOrgVm.zipCode = formValues.zipCode;
      this.addOrgVm.cityID = parseInt(formValues.cityId);
      this.addOrgVm.countryID = parseInt(formValues.countryId);
      this.addOrgVm.address1 = formValues.address1;
      this.addOrgVm.address2 = formValues.address2;
      this.addOrgVm.organizationID = this.updateOrganizationDetail.organizationID;
      this.addOrgVm.organizationName = this.updateOrganizationDetail.organizationName;
      this.addOrgVm.email = this.updateOrganizationDetail.email;
    }
    this.loaderService.show();
    //return;
    this.organizationService.updateOrganization(this.addOrgVm).subscribe(response => {
      this.updatePermissionResponseHolder = response;
      this.loaderService.hide();
      if (this.updatePermissionResponseHolder.status === this.statusConst.statusSuccess) {
        let closePanel = true;
        this.closeSidePanel.emit(closePanel);
        this.toastr.success("Organization updated successfully.", '', {
          timeOut: 3000,
        });
        //this.dialogRef.close(updateSelectedDetail);
      } else {
        this.loaderService.hide();
        this.toastr.error(this.updatePermissionResponseHolder.message, '', {
          timeOut: 3000,
        });
      }
    });
  }

  //Summary
  //Check Validate token length and enable Confirm button
  checkValidatorLength() {
    if (this.updateOrganizationDetail.zipCode.length < 3 || this.updateOrganizationDetail.zipCode.length > 6) {
      this.showErrorMessage = true;
    }
    else {
      this.showErrorMessage = false;
    }
  }

  getCountryListDropdown() {
    this.organizationService.getCountryList().subscribe(response => {
      if (response) {
        this.coutryListResponseHolder = response;
        if (this.coutryListResponseHolder.status == this.statusConst.statusSuccess) {
          this.countryList = this.coutryListResponseHolder.data;
        }
      }
    });
  }

  getStateDropdownList() {
    this.organizationService.getStateList(this.updateOrganizationDetail.countryID).subscribe(response => {
      if (response) {
        this.stateListRResponseHolder = response;
        if (this.stateListRResponseHolder.status == this.statusConst.statusSuccess) {
          if(this.updateOrganizationDetail.countryID == 231 || this.updateOrganizationDetail.countryID == 38){              
            this.stateListRResponseHolder.data  =  this.stateListRResponseHolder.data.filter((x) => x.abbreviation != null);
            this.stateList = this.stateListRResponseHolder.data;
           // this._stateList=this.stateListRResponseHolder.data;
          }else{
            this.stateList = this.stateListRResponseHolder.data;
           // this._stateList=this.stateListRResponseHolder.data;
          } 
         // this.stateList = this.stateListRResponseHolder.data;
        }
      }
    });
  }

  getCityDropdownList() {
      this.organizationService.getCityList(this.updateOrganizationDetail.stateID).subscribe(response => {
        if (response) {
          this.cityListRResponseHolder = response;
          if (this.cityListRResponseHolder.status == this.statusConst.statusSuccess) {
            this.cityList = this.cityListRResponseHolder.data;
          }
        }
      });
  }

}
